import { useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import CircleMenu from '../CircleMenu';
import srv from '../../../services';
import Cookies from 'js-cookie';

declare const window: any;

const ChatwootWidget = () => {
 const contracts =
  useQueryClient().getQueryData<Models.Contract[]>('contracts');
 const contragent =
  useQueryClient().getQueryData<Models.Contragent>('contragent');

 const [attribute, setAttribute] = useState(false);
 const [userData, setUserData] = useState<any>();

 const getUserData = async () => {
  /**
   * Получить данные пользователя.
   */
  const userData = await srv.getUser();
  setUserData(userData);

  localStorage.setItem(
   'phone',
   userData && userData?.phone ? userData.phone : null
  );
  localStorage.setItem(
   'email',
   userData && userData?.email ? userData.email : null
  );
 };

 /**
  * Получить короткую ссылку/
  * @returns
  */
 const getAuthorizationData = async () => {
  const chatWootUrl = 'https://chatwoot-k8s.vostok-electra.ru/';

  const payload = {
   key: 'e104af65008b0c8b5cd5bf233b26f0885aeb192eb7b6586cdb3d2d396654228f',
   secret:
    'bc5c0fe409be55a1196fa64182f51d230ea9ef0074525a7859f70f21dea7772583ce5326c1f43dc266ad143c95d8b7dc2d7a96bcde7365f60ab84d33e4eac0f2',
  };

  let responseToken: any = '';
  let resultUrl: any = '';
  let cookie: any = '';
  let responseObject: any = null;

  responseToken = await srv.getAuthenticationToken(payload);

  if (responseToken && responseToken.accessToken) {
   const accessToken = responseToken.accessToken;

   let conversation = Cookies.get('cw_conversation');

   if (conversation) {
    cookie = 'cw_conversation=' + conversation;

    resultUrl =
     chatWootUrl + 'widget?website_token=44DLbKjuqDKkqjkddoNd7w5Y&' + cookie;

    const headers = {
     'Content-Type': 'application/json',
     Accept: '*/*',
     Authorization: `Bearer ${accessToken}`,
    };

    responseObject = {
     resultUrl: resultUrl,
     headers: headers,
    };

    return responseObject;
   }
  }

  return responseObject;
 };

 const getShortData = async (resultUrl, headers) => {
  const domainBase = 'ulk_vostok_electra';

  // Добавил время жизни короткой ссылки
  const payloadShorter = {
   domainId: domainBase,
   url: resultUrl,
   daysOfLife: 1825,
  };

  let shortUrl = '';

  const responseShorter = await srv.getShortUrl(payloadShorter, headers);

  if (responseShorter && responseShorter.url) {
   shortUrl = responseShorter.url;
   console.log('короткая ссылка сформирована.');

   let foundContracts = null;
   const contractsStorage = localStorage.getItem('contracts');

   if (contractsStorage && contractsStorage === 'null') {
    foundContracts = JSON.parse(localStorage.getItem('contracts'));
   } else {
    foundContracts = localStorage.getItem('contracts');
   }

   window.$chatwoot.setConversationsAttributes({
    lk: foundContracts,
    url: shortUrl,
    source: '8',
    phone: localStorage.getItem('phone'),
    emailAddress: localStorage.getItem('email'),
   });
  }
 };

 const getShortUrl = async () => {
  if (!attribute) {
   setAttribute(true);

   const authData = await getAuthorizationData();

   if (authData) {
    await getShortData(authData.resultUrl, authData.headers);
   }
  }
 };

 useEffect(() => {
  localStorage.removeItem('contracts');
  localStorage.setItem('contracts', null);
  getUserData();
 }, []);

 useEffect(() => {
  (function (d, t) {
   var BASE_URL = 'https://chatwoot-k8s.vostok-electra.ru/';
   var g: any = d.createElement(t),
    s = d.getElementsByTagName(t)[0];

   g.src = BASE_URL + '/packs/js/sdk.js';
   g.defer = true;
   g.async = true;
   s.parentNode.insertBefore(g, s);

   g.onload = function () {
    if (contracts && contracts.length > 0) {
     const contractsFound =
      contracts
       .map((item) => {
        return item?.number;
       })
       .join() || null;
     localStorage.setItem('contracts', contractsFound);
    }

    window.chatwootSDK.run({
     websiteToken: '44DLbKjuqDKkqjkddoNd7w5Y',
     baseUrl: BASE_URL,
    });
    // window.$chatwoot.setConversationsAttributes({
    //   lk:
    //     contracts
    //       .map((item) => {
    //         return item?.number;
    //       })
    //       .join() || null,
    //   source: '8',
    // });
   };
   window.addEventListener(
    'chatwoot:on-message',
    function () {
     getShortUrl();
    },
    { once: true }
   );
  })(document, 'script');
 }, [contracts]);

 return <CircleMenu />;
};

export default ChatwootWidget;
